"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CacheStore2 = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/CacheStore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Component cache store.
 */
var ComponentCacheStore = /*#__PURE__*/function (_CacheStore) {
  _inherits(ComponentCacheStore, _CacheStore);

  var _super = _createSuper(ComponentCacheStore);

  function ComponentCacheStore() {
    _classCallCheck(this, ComponentCacheStore);

    return _super.apply(this, arguments);
  }

  _createClass(ComponentCacheStore, [{
    key: "removeEvents",

    /**
     * Removes stored events based on the unique event id generated by events().
     *
     * @param {string} uniqueId Unique events ID generated by the events() method.
     */
    value: function removeEvents(uniqueId) {
      var events = this.get('events');

      if (events !== undefined && events[uniqueId] !== undefined) {
        delete events[uniqueId];
      }
    }
    /**
     * Returns stored events based on the unique event id generated by events().
     *
     * @param {string} uniqueId Unique events ID generated by the events() method.
     * @returns {object|null} Defined events.
     */

  }, {
    key: "getEvents",
    value: function getEvents(uniqueId) {
      var events = this.get('events');
      return events !== undefined && events[uniqueId] !== undefined ? events[uniqueId] : null;
    }
    /**
     * Adds stored events to a cache store.
     *
     * @param {object} events Events to store.
     * @returns {string} Store ID.
     */

  }, {
    key: "addEvents",
    value: function addEvents(events) {
      return this._addPropsOrEvents('events', events);
    }
    /**
     * Removes a stored props based on the unique props id generated by props().
     *
     * @param {string} uniqueId Unique props ID generated by the props() method.
     */

  }, {
    key: "removeProps",
    value: function removeProps(uniqueId) {
      var props = this.get('props');

      if (props !== undefined && props[uniqueId] !== undefined) {
        delete props[uniqueId];
      }
    }
    /**
     * Returns stored props based on the unique props id generated by props().
     *
     * @param {string} uniqueId Unique props ID generated by the props() method.
     * @returns {object|null} Defined Props.
     */

  }, {
    key: "getProps",
    value: function getProps(uniqueId) {
      var props = this.get('props');
      return props !== undefined && props[uniqueId] !== undefined ? props[uniqueId] : null;
    }
    /**
     * Adds stored props to a cache store.
     *
     * @param {object} props Props to store.
     * @returns {string} Store ID.
     */

  }, {
    key: "addProps",
    value: function addProps(props) {
      return this._addPropsOrEvents('props', props);
    }
    /**
     * Adds stored props to a cache store.
     *
     * @param {string} type "props" or "events".
     * @param {object} values Values to store.
     * @returns {string} Store ID.
     */

  }, {
    key: "_addPropsOrEvents",
    value: function _addPropsOrEvents(type, values) {
      var storedValues = this.get(type);

      if (!storedValues) {
        storedValues = {
          id: 0
        };
        this.set(type, storedValues);
      }

      var id = storedValues.id;
      storedValues.id++;
      storedValues['#' + id] = values;
      return '#' + id;
    }
  }]);

  return ComponentCacheStore;
}(_CacheStore2.default);

exports.default = ComponentCacheStore;